import React, { useState } from 'react';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [open, setOpen] = useState<ModalType>(null);
  return <>
      <footer className="bg-stone-900 text-stone-400 py-12 text-center text-sm" data-id="element-27">
        <div className="container mx-auto px-4" data-id="element-28">
          <p className="mb-4" data-id="element-29">
            © {new Date().getFullYear()} Rutinas Visuales sin Gritos. Todos los
            derechos reservados.
          </p>
          <p className="mb-6" data-id="element-30">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera.
          </p>
          <div className="flex items-center justify-center gap-6" data-id="element-31">
            <button onClick={() => setOpen('privacy')} className="text-stone-400 hover:text-amber-400 underline underline-offset-2 transition-colors duration-200" data-id="element-32">
              Política de Privacidad
            </button>
            <span className="text-stone-600" data-id="element-33">·</span>
            <button onClick={() => setOpen('terms')} className="text-stone-400 hover:text-amber-400 underline underline-offset-2 transition-colors duration-200" data-id="element-34">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Modal Overlay */}
      {open && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setOpen(null)} data-id="element-35">
          <div className="relative bg-white rounded-3xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()} data-id="element-36">
            {/* Modal Header */}
            <div className="flex items-center justify-between px-8 py-6 border-b border-stone-100" data-id="element-37">
              <h2 className="text-2xl font-extrabold text-stone-900" data-id="element-38">
                {open === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h2>
              <button onClick={() => setOpen(null)} className="w-9 h-9 flex items-center justify-center rounded-full bg-stone-100 hover:bg-stone-200 text-stone-500 transition-colors" data-id="element-39">
                <X className="w-5 h-5" data-id="element-40" />
              </button>
            </div>

            {/* Modal Body */}
            <div className="overflow-y-auto px-8 py-6 text-stone-600 text-sm leading-relaxed space-y-4" data-id="element-41">
              {open === 'privacy' ? <PrivacyContent data-id="element-42" /> : <TermsContent data-id="element-43" />}
            </div>

            {/* Modal Footer */}
            <div className="px-8 py-4 border-t border-stone-100 bg-stone-50 text-right" data-id="element-44">
              <button onClick={() => setOpen(null)} className="px-6 py-2.5 bg-amber-500 hover:bg-amber-600 text-white font-bold rounded-full text-sm transition-colors" data-id="element-45">
                Entendido
              </button>
            </div>
          </div>
        </div>}
    </>;
}
function PrivacyContent() {
  return <>
      <p className="text-stone-400 text-xs" data-id="element-46">
        Última actualización: {new Date().getFullYear()}
      </p>

      <h3 className="font-bold text-stone-800 text-base" data-id="element-47">
        1. Información que recopilamos
      </h3>
      <p data-id="element-48">
        Al adquirir nuestro producto digital{' '}
        <strong data-id="element-49">Rutinas Visuales sin Gritos</strong>, podemos recopilar
        información básica como tu nombre y dirección de correo electrónico,
        únicamente con el propósito de procesar tu compra y entregarte el
        producto.
      </p>

      <h3 className="font-bold text-stone-800 text-base" data-id="element-50">
        2. Uso de la información
      </h3>
      <p data-id="element-51">La información recopilada se utiliza exclusivamente para:</p>
      <ul className="list-disc list-inside space-y-1 pl-2" data-id="element-52">
        <li data-id="element-53">Procesar y confirmar tu compra.</li>
        <li data-id="element-54">Enviarte el acceso al producto digital adquirido.</li>
        <li data-id="element-55">
          Enviarte comunicaciones relacionadas con el producto, si así lo
          autorizas.
        </li>
      </ul>

      <h3 className="font-bold text-stone-800 text-base" data-id="element-56">
        3. Compartir información con terceros
      </h3>
      <p data-id="element-57">
        No vendemos, alquilamos ni compartimos tu información personal con
        terceros, excepto cuando sea necesario para procesar pagos a través de
        plataformas seguras de pago (como Stripe, PayPal u otras). Estas
        plataformas tienen sus propias políticas de privacidad.
      </p>

      <h3 className="font-bold text-stone-800 text-base" data-id="element-58">4. Cookies</h3>
      <p data-id="element-59">
        Este sitio puede utilizar cookies técnicas para mejorar la experiencia
        de navegación. No utilizamos cookies de seguimiento de terceros sin tu
        consentimiento.
      </p>

      <h3 className="font-bold text-stone-800 text-base" data-id="element-60">5. Seguridad</h3>
      <p data-id="element-61">
        Tomamos medidas razonables para proteger tu información personal. Sin
        embargo, ningún método de transmisión por Internet es 100% seguro.
      </p>

      <h3 className="font-bold text-stone-800 text-base" data-id="element-62">6. Tus derechos</h3>
      <p data-id="element-63">
        Tienes derecho a acceder, rectificar o eliminar tu información personal
        en cualquier momento. Para ejercer estos derechos, puedes comunicarte
        con nosotros a través de los medios indicados en la plataforma de
        compra.
      </p>

      <h3 className="font-bold text-stone-800 text-base" data-id="element-64">
        7. Cambios en esta política
      </h3>
      <p data-id="element-65">
        Nos reservamos el derecho de actualizar esta política en cualquier
        momento. Los cambios serán publicados en esta misma página.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-stone-400 text-xs" data-id="element-66">
        Última actualización: {new Date().getFullYear()}
      </p>

      <h3 className="font-bold text-stone-800 text-base" data-id="element-67">
        1. Aceptación de los términos
      </h3>
      <p data-id="element-68">
        Al adquirir y/o utilizar el producto digital{' '}
        <strong data-id="element-69">Rutinas Visuales sin Gritos</strong>, aceptas plenamente estos
        Términos y Condiciones. Si no estás de acuerdo, te pedimos que no
        realices la compra.
      </p>

      <h3 className="font-bold text-stone-800 text-base" data-id="element-70">
        2. Descripción del producto
      </h3>
      <p data-id="element-71">
        <strong data-id="element-72">Rutinas Visuales sin Gritos</strong> es un ebook digital en
        formato PDF que incluye contenido educativo, plantillas imprimibles y un
        plan de implementación de 14 días orientado a familias con niños en edad
        preescolar y escolar.
      </p>

      <h3 className="font-bold text-stone-800 text-base" data-id="element-73">3. Uso personal</h3>
      <p data-id="element-74">
        Este producto está licenciado para uso personal y no comercial. Queda
        estrictamente prohibido:
      </p>
      <ul className="list-disc list-inside space-y-1 pl-2" data-id="element-75">
        <li data-id="element-76">Reproducir, distribuir o revender el contenido.</li>
        <li data-id="element-77">Compartir el archivo con terceros fuera del núcleo familiar.</li>
        <li data-id="element-78">
          Utilizar el contenido con fines comerciales sin autorización expresa.
        </li>
      </ul>

      <h3 className="font-bold text-stone-800 text-base" data-id="element-79">
        4. Política de reembolso
      </h3>
      <p data-id="element-80">
        Dado que se trata de un producto digital de acceso inmediato, no se
        realizan reembolsos una vez que el archivo ha sido descargado o el
        acceso ha sido entregado. Si tienes algún problema técnico con tu
        compra, contáctanos y lo resolveremos.
      </p>

      <h3 className="font-bold text-stone-800 text-base" data-id="element-81">5. Resultados</h3>
      <p data-id="element-82">
        Los resultados descritos en este sitio son representativos y no
        garantizados. Los resultados individuales pueden variar según la
        constancia, la edad del niño y las circunstancias de cada familia.
      </p>

      <h3 className="font-bold text-stone-800 text-base" data-id="element-83">
        6. Propiedad intelectual
      </h3>
      <p data-id="element-84">
        Todo el contenido de este producto —textos, diseños, plantillas e
        ilustraciones— es propiedad exclusiva de sus creadores y está protegido
        por las leyes de propiedad intelectual aplicables.
      </p>

      <h3 className="font-bold text-stone-800 text-base" data-id="element-85">7. Modificaciones</h3>
      <p data-id="element-86">
        Nos reservamos el derecho de modificar estos términos en cualquier
        momento. Las modificaciones entrarán en vigor desde su publicación en
        este sitio.
      </p>
    </>;
}